export function hasElements<T>(value: T[] | null | undefined): value is T[] {
  return value != null && value.length > 0;
}
